document.addEventListener('DOMContentLoaded', () => {
  // Open cart if the hash is #cart
  if (window.location.hash == "#cart" && document.querySelector('[data-js-site-cart-sidebar]') !== null) {
    document.querySelector('[data-js-site-cart-sidebar]').show();
    window.location.hash = '';
  }
});

// Cart upsell quick add
window.addEventListener("load", bindCartEvents);
document.addEventListener('cart:refreshed', () => {
  setTimeout(bindCartEvents, 850);
});
function bindCartEvents() {
  document.querySelectorAll('.upsell-quick-add').forEach(function (quickAddButton) {
    quickAddButton.addEventListener('click', function (e) {
      e.preventDefault();
      let variantId = parseInt(quickAddButton.dataset.id);
      fetch('/cart/add.js', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            quantity: 1,
            id: variantId
          }]
        })
      }).then(response => {
        if (!response.ok) {
          throw new Error('An error occurred while adding the product to the cart');
        }
        return response.json();
      }).then(() => {
        window.refreshCart();
      }).catch(e => {
        console.error(e);
      });
    });
  });
}

// Wishlist translations
function setText(selector, text) {
  const element = document.querySelector(selector);
  if (element) {
    element.innerText = text;
  }
}
function setTextAll(selector, text) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    element.innerText = text;
  });
}
function setHTML(selector, html) {
  const element = document.querySelector(selector);
  if (element) {
    element.innerHTML = html;
  }
}
function WishlistLoadedCallback() {
  /* Remove all empty p tags with class "variant_title" */
  const elements = document.querySelectorAll('.variant_title');
  elements.forEach(element => {
    if (!element.innerText.trim()) {
      element.parentNode.removeChild(element);
    }
  });

  /* TRANSLATIONS */
  setText('.titletext', window.i18n.wishlist['title']);
  setText('.sharebutton', window.i18n.wishlist['btn_share']);
  setText('.clearall', window.i18n.wishlist['btn_delete_all']);
  setText('#addallbutton', window.i18n.wishlist['btn_add_all']);
  setTextAll('.addsingleproduct', window.i18n.wishlist['btn_add_to_cart']);
  setTextAll('.singleremovebutton', window.i18n.wishlist['btn_delete']);
  setText('#modal_remove_all_button', window.i18n.wishlist['btn_delete_all']);
  setText('#remove_all_modal_label', window.i18n.wishlist.modal['delete_all_title']);
  setText('#share_modal_label', window.i18n.wishlist.modal['share_title']);
  setText('#message_modal_text', window.i18n.wishlist.modal['add_text']);
  setText('#remove_modal_label', window.i18n.wishlist.modal['delete_title']);
  setTextAll('.btn-default-modal', window.i18n.wishlist['btn_close']);
  setText('.btn-warning-modal', window.i18n.wishlist['btn_delete']);
  setText('.empty-wishlist', window.i18n.wishlist['no_product']);
  setText('#sw_wishlist_label', window.i18n.wishlist['no_product']);
  setHTML('.sw-login-notification', `${window.i18n.wishlist['login_reminder']} <a href="/account/login">${window.i18n.wishlist['btn_login']}</a>`);
}